module.exports = __webpack_public_path__ + "static/media/wrong.b53ef06b.wav";